import React, { useState } from "react";
import Select from "react-select";

const SearchTypesSelect = (props) => {
  const reasons = [
    { value: "internal", label: "Interna" },
    { value: "external", label: "Externa" },
    { value: "mixed", label: "Mixta" }
  ];

  const [searchType] = useState(reasons);

  const handleChangeLevel = inputValue => {
    props.handleChange(inputValue, "searchType");
  };

  return (
    <Select
      inputId="searchType"
      onChange={handleChangeLevel}
      options={searchType}
      placeholder="Seleccione una opción"
      value={searchType.find(
        (option) => option.value === props.value?.value
      ) || null}
    />
  );
};

export default SearchTypesSelect;
